import { render, staticRenderFns } from "./wzQuestion.vue?vue&type=template&id=2d22cdac&scoped=true&"
import script from "./wzQuestion.vue?vue&type=script&lang=js&"
export * from "./wzQuestion.vue?vue&type=script&lang=js&"
import style0 from "./wzQuestion.vue?vue&type=style&index=0&id=2d22cdac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22cdac",
  null
  
)

export default component.exports